<template>
  <v-main class="document pt-5" style="margin: 0 auto">
    <v-container v-if="!loading" class="container-print">
      <div class="row px-6 pt-6">
        <div class="col pl-0">
          <h1 class="primary--text">{{ fields.celebration && fields.celebration.name }}</h1>
          Conta Heppi: <b>{{ fields.celebration && fields.celebration.account }}</b>
          <br />
          Responsável: {{ fields.celebration && fields.celebration.ownerName }}
          <br />
          CPF/CNPJ: {{ fields.celebration && fields.celebration.ownerDocument | document }}
        </div>
        <div class="col-auto text-right primary--text">
          <img src="@/assets/logo-heppi.png" srcset="@/assets/logo-heppi@2x.png 2x" style="height: 40px" />
          <br>
          <h3>Extrato da Conta Heppi</h3>
          <span class="caption">Período: {{ firstDay | moment('DD/MM/YYYY') }} à {{ nowDate }}</span>
        </div>
      </div>
      <div class="row px-5 pt-2">
        <div class="col-6"></div>
        <div class="col text-right">
          <small>Saldo</small>
          <br>
          <h4 class="text-bold">{{ fields.celebration && fields.celebration.availableBalance | price }}</h4>
        </div>
        <div class="col text-right">
          <small>À liberar</small>
          <br>
          <h4 class="text-bold">{{ fields.celebration && fields.celebration.unavailableBalance | price }}</h4>
        </div>
      </div>
      <div class="pa-4 details">
        <template v-for="(month, monthKey) in financialItems">
          <h3 class="primary--text text-uppercase" :class="firstMonth !== monthKey ? 'pt-10' : ''" :key="monthKey">{{ monthKey | moment('MMMM YYYY') }}</h3>
          <template v-for="(day, dayKey) in month">
            <h4 :key="'title-' + dayKey" class="primary--text pt-5">{{ dayKey | moment('DD MMMM YYYY') }}</h4>
            <v-divider :key="'divider-' + dayKey" class="pb-3" />
            <div class="pb-1 row" style="break-inside: avoid" v-for="(item, index) in day" :key="dayKey + '-' + index">

              <template v-if="item.category === 'invoice'">
                <div class="col-4">
                  Fatura Heppi
                  <div class="caption">{{ item.customerDocument | documentMasked }} | {{ item.customer }}</div>
                </div>
                <div class="col">
                  <div class="row pt-3">
                    <div class="col py-0">Arrecadação</div>
                    <div class="col-auto py-0">{{ item.fundraising | price }}</div>
                  </div>
                  <div class="row pt-0">
                    <div class="col py-0">Taxa Heppi</div>
                    <div class="col-auto py-0">{{ item.heppiFee | price }}</div>
                  </div>
                  <div v-if="item.split100" class="row pt-0">
                    <div class="col py-0">
                      Split (100%)
                    </div>
                    <div class="col-auto py-0">{{ item.split100 | price }}</div>
                    <div class="col-12 py-0">
                      <div class="caption">{{ splitAccounts.split100.account }} | {{ splitAccounts.split100.name }}</div>
                      <div class="caption">{{ splitAccounts.split100.document | document }}</div>
                    </div>
                  </div>
                  <div v-if="item.split75" class="row pt-0">
                    <div class="col py-0">
                      Split (75%)
                    </div>
                    <div class="col-auto py-0 no-wrap">{{ item.split75 | price }}</div>
                    <div class="col-12 py-0">
                      <div class="caption">{{ splitAccounts.split75.account }} | {{ splitAccounts.split75.name }}</div>
                      <div class="caption">{{ splitAccounts.split75.document | document }}</div>
                    </div>
                  </div>
                  <div v-if="item.split25" class="row pt-0">
                    <div class="col py-0">
                      Split (25%)
                    </div>
                    <div class="col-auto py-0">{{ item.split25 | price }}</div>
                    <div class="col-12 py-0">
                      <div class="caption">{{ splitAccounts.split25.account }} | {{ splitAccounts.split25.name }}</div>
                      <div class="caption">{{ splitAccounts.split25.document | document }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-3 text-right no-wrap">{{ item.amount | price }}</div>
              </template>

              <template v-else-if="item.category === 'transfer'">
                <div class="col-4">
                  Transferência
                  <div class="caption">{{ item.company.account }} | {{ item.company.name }}</div>
                  <div class="caption">{{ item.company.document | document }}</div>
                </div>
                <div class="col">
                  {{ item.description }}
                </div>
                <div class="col-3 text-right no-wrap">{{ item.amount | price }}</div>
              </template>

              <template v-else-if="item.category === 'request_withdraw'">
                <div class="col-4">
                  Resgate
                </div>
                <div class="col">
                  {{ item.description }}
                </div>
                <div class="col-3 text-right no-wrap">{{ item.amount | price }}</div>
              </template>
            </div>
          </template>
        </template>
      </div>
      <div class="pa-4 text-right">
        <i class="caption">Documento gerado no dia {{ now }}</i>
      </div>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import financialData from './financial_details.json'
// import Notes from '@/components/Print/Notes'
// import Invoices from '@/components/Print/Invoices'
// import Fundraisings from '@/components/Print/Fundraisings'
// import NextInvoices from '@/components/Print/NextInvoices'

export default {
  name: 'fundraisingForm',
  components: {
    AppLoading
    // Notes,
    // Invoices,
    // Fundraisings,
    // NextInvoices
  },
  props: ['id'],
  data: () => ({
    loading: false,
    documentName: 'Ficha Financeira',
    fields: {
      celebration: {
        name: '',
        account: '',
        ownerName: '',
        ownerDocument: '',
        availableBalance: 0,
        unavailableBalance: 0
      }
    },
    firstMonth: null,
    firstDay: null,
    financialItems: {},
    splitAccounts: {
      split25: {
        account: '40830-0',
        name: 'Arcádia',
        document: '35471317000190'
      },
      split75: {
        account: '24485-8',
        name: 'Novaera Nordeste',
        document: '14180974000109'
      },
      split100: {
        account: '24485-8',
        name: 'Novaera Nordeste',
        document: '14180974000109'
      }
    },
    reportSections: {
      info: false,
      fundraisings: false,
      paid: false,
      pending: false,
      next: false,
      notes: false
    },
    now: '',
    nowDate: ''
  }),
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    async getData () {
      this.loading = true
      if (financialData) {
        const accountID = financialData[0].account_id
        const accountInfo = await axios.get('accounts/' + accountID + '?api_key=' + accountID, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        this.fields.celebration.name = accountInfo.data.name.replace('Novaera Nordeste - ', '')
        this.fields.celebration.account = accountInfo.data.account_number
        this.fields.celebration.ownerName = accountInfo.data.owner.name
        this.fields.celebration.ownerDocument = accountInfo.data.owner.document
        this.fields.celebration.availableBalance = accountInfo.data.available_balance
        this.fields.celebration.unavailableBalance = accountInfo.data.unavailable_balance

        document.title = 'Extrato - ' + this.fields.celebration.name

        this.financialItems = {}
        this.firstMonth = null
        this.firstDay = null

        financialData.sort((a, b) => {
          return Number(this.$moment(a.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('x')) - Number(this.$moment(b.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('x'))
        })

        for (const index in financialData) {
          const paymentDate = this.$moment(financialData[index].payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM-DD')
          const paymentMonth = this.$moment(financialData[index].payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM')
          // const category = financialData[index].category

          if (!this.firstMonth) {
            this.firstMonth = paymentMonth
          }
          if (!this.firstDay) {
            this.firstDay = paymentDate
          }

          if (!this.financialItems[paymentMonth]) {
            this.financialItems[paymentMonth] = {}
          }

          if (!this.financialItems[paymentMonth][paymentDate]) {
            this.financialItems[paymentMonth][paymentDate] = []
          }

          if (financialData[index].invoice) {
            const invoiceIndex = this.financialItems[paymentMonth][paymentDate].findIndex(e => e.invoice === financialData[index].invoice.heppi)
            let fundraising = 0
            if (['fundraising', 'interest_and_fines', 'renegotiation', 'aditional', 'discount'].includes(financialData[index].category)) {
              fundraising = (financialData[index].financial_type === 'debit') ? -financialData[index].amount : financialData[index].amount
            }
            let heppiFee = 0
            if (['heppi_fee'].includes(financialData[index].category)) {
              heppiFee = (financialData[index].financial_type === 'debit') ? -financialData[index].amount : financialData[index].amount
            }
            let split100 = 0
            if (['split'].includes(financialData[index].category) && (financialData[index].description.includes('100.00%') || !financialData[index].description.includes('%'))) {
              split100 = (financialData[index].financial_type === 'debit') ? -financialData[index].amount : financialData[index].amount
            }
            let split75 = 0
            if (['split'].includes(financialData[index].category) && financialData[index].description.includes('75.00%')) {
              split75 = (financialData[index].financial_type === 'debit') ? -financialData[index].amount : financialData[index].amount
            }
            let split25 = 0
            if (['split'].includes(financialData[index].category) && financialData[index].description.includes('25.00%')) {
              split25 = (financialData[index].financial_type === 'debit') ? -financialData[index].amount : financialData[index].amount
            }
            let chargeBack = 0
            if (['charged_back', 'charged_back_in_proccess'].includes(financialData[index].category)) {
              chargeBack = (financialData[index].financial_type === 'debit') ? -financialData[index].amount : financialData[index].amount
            }
            let refunded = 0
            if (['refunded'].includes(financialData[index].category)) {
              refunded = (financialData[index].financial_type === 'debit') ? -financialData[index].amount : financialData[index].amount
            }

            if (invoiceIndex >= 0) {
              const val = this.financialItems[paymentMonth][paymentDate][invoiceIndex]
              this.financialItems[paymentMonth][paymentDate][invoiceIndex] = {
                ...val,
                fundraising: val.fundraising + fundraising,
                heppiFee: val.heppiFee + heppiFee,
                split100: val.split100 + split100,
                split75: val.split75 + split75,
                split25: val.split25 + split25,
                chargeBack: val.chargeBack + chargeBack,
                refunded: val.refunded + refunded,
                amount: val.fundraising + fundraising + val.heppiFee + heppiFee + val.split100 + split100 + val.split75 + split75 + val.split25 + split25 + val.chargeBack + chargeBack + val.refunded + refunded
              }
            } else {
              this.financialItems[paymentMonth][paymentDate].push({
                category: 'invoice',
                invoice: financialData[index].invoice.heppi,
                customer: financialData[index].customer.name,
                customerDocument: financialData[index].customer.document,
                fundraising,
                heppiFee,
                split100,
                split75,
                split25,
                chargeBack,
                refunded,
                amount: fundraising + heppiFee + split100 + split75 + split25 + chargeBack + refunded
              })
            }
          } else {
            const company = financialData[index].financial_type === 'debit' ? financialData[index].receiver || null : financialData[index].sender || null
            if (financialData[index].processor === 'iugu' && (company.name === '4367 - FMN 2020.2 Arquitetura + Engenharia' || company.name === '4648 - UNINASSAU 2020.1 - Engenharias + Arquitetura')) {
              company.account = '24485-8'
              company.name = 'Novaera Nordeste'
              company.document = '14180974000109'
            }

            if (financialData[index].processor === 'iugu' && company.name === 'ARCÁDIA') {
              company.account = '40830-0'
              company.name = 'Arcádia'
              company.document = '35471317000190'
            }

            if (financialData[index].processor === 'mercado-pago' && company && company.id) {
              if (company.name === 'Mercado Pago') {
                company.account = '70226-1'
                company.name = 'Mercado Pago - Heppi'
                company.document = '38661528000184'
              } else if (company.name === 'Getnet') {
                company.account = '70226-1'
                company.name = 'Getnet - Heppi'
                company.document = '38661528000184'
              } else {
                const accountID = company.id
                const accountInfo = await axios.get('accounts/' + accountID + '?api_key=' + accountID, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
                company.account = accountInfo?.data?.account_number || ''
                company.name = accountInfo?.data?.name || ''
                company.document = accountInfo?.data?.owner?.document || ''
              }
            }

            this.financialItems[paymentMonth][paymentDate].push({
              category: financialData[index].category,
              company,
              description: financialData[index].description.replace('4367 - FMN 2020.2 Arquitetura + Engenharia', 'Novaera Nordeste').replace('4648 - UNINASSAU 2020.1 - Engenharias + Arquitetura', 'Novaera Nordeste'),
              amount: financialData[index].financial_type === 'debit' ? -financialData[index].amount : financialData[index].amount
            })
          }
        }
      }
      this.loading = false
    }
  },
  async created () {
    // if (this.id) {
    // const queryData = this.$route.query || {}
    // this.documentName = queryData.title || 'Ficha Financeira'
    // this.reportSections.info = !!queryData.info
    // this.reportSections.fundraisings = !!queryData.fundraisings
    // this.reportSections.paid = !!queryData.paid
    // this.reportSections.pending = !!queryData.pending
    // this.reportSections.next = !!queryData.next
    // this.reportSections.notes = !!queryData.notes
    this.getData()
    // } else {
    //   this.$router.go(-1)
    // }

    this.now = this.$moment().format('DD/MM/YYYY HH:mm')
    this.nowDate = this.$moment().format('DD/MM/YYYY')
  }
}
</script>

<style>
.container-print {
  padding: 30px;
}

.details .caption {
  line-height: 1.2em;
}

@media print {
  .container-print {
    padding: 0;
    margin-top: -0.5cm;
    max-width: 28cm;
  }
}

@page { margin: 1cm 0 !important } /* All margins set to 2cm */

</style>
